// extracted by mini-css-extract-plugin
module.exports = {"appointmentModalRoot":"index-appointmentModalRoot-2hU06"};